import React, { useState } from "react"
import {
  Button,
  Col,
  Divider,
  Drawer,
  Row,
  Image,
  Descriptions,
  Input,
  InputNumber,
  Form,
  message,
} from "antd"
import { doc, serverTimestamp, updateDoc } from "firebase/firestore"
import { db } from "../../firebase/config"
import { useNavigate } from "react-router-dom"
import { useAuthContext } from "../../hooks/useAuthContext"
import SplitOrderDrawer from "./SplitOrderDrawer"

const { TextArea } = Input

export default function TapeFillOrderDrawer({ orderData, tapeSequence }) {
  const [open, setOpen] = useState(false)
  const { user } = useAuthContext()
  const navigate = useNavigate()
  const [form] = Form.useForm()

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  //updates doc
  const updateOrder = async (object) => {
    const orderRef = doc(db, "orders", orderData.id)
    try {
      await updateDoc(orderRef, {
        tapePrinter: user.uid,
        tapePrinterEmail: user.email,
        updated: serverTimestamp(),
        doneByTape: serverTimestamp(),
        updatedBy: user.email,
        orderFinished: true,
        clientReceivesRolls: object.clientReceives,
        tapeComment: object.tapeComment,
        orderStatus: 6,
        hasRoll: false,
      })
      message.success("Order updated!")

      const newSequence = await tapeSequence.filter((item) => item !== orderData.id)
      const sequenceDocRef = doc(db, "sequence", "q1f62HLhOvGSo9ZtmSEb")
      await updateDoc(sequenceDocRef, {
        tapeSequence: newSequence,
      })

      for (const roll of orderData.assignedRollIds) {
        const rollRef = doc(db, "rolls", roll)
        await updateDoc(rollRef, {
          inUse: false,
          currentlyUsing: false,
          assignedOrderId: null,
          assignedTo: null,
          updated: serverTimestamp(),
        })
      }

      navigate(`/tape/orders`)
    } catch (error) {
      console.log(error.message)
      message.error(error.message)
    }
  }

  //form
  const onFinish = (values) => {
    console.log("Success:", values)
    updateOrder(values)
    setOpen(false)
    // manage sequence cleanup
    form.resetFields()
  }
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  return (
    <>
      <Button size="small" type="primary" onClick={showDrawer}>
        Fill Order
      </Button>
      <Drawer title="Fill Order" placement="left" onClose={onClose} open={open}>
        <Row gutter={[15, 15]}>
          <Col span={24}>
            <Divider>Order Details</Divider>
            <Image src={orderData.technicalPage} />
            <Descriptions column={1}>
              <Descriptions.Item label="Client"> {orderData.client.client}</Descriptions.Item>
              <Descriptions.Item label="Product">
                {" "}
                {orderData.selectedProduct.product.productName}
              </Descriptions.Item>
              <Descriptions.Item label="Manager"> {orderData.user}</Descriptions.Item>
              <Descriptions.Item label="Box Count"> {orderData.boxCount}</Descriptions.Item>
              <Descriptions.Item label="Roll Count"> {orderData.rollCount}</Descriptions.Item>
              <Descriptions.Item label="Roll Size">
                {" "}
                {orderData.selectedProduct.tapeWidth} mm
              </Descriptions.Item>
              <Descriptions.Item label="Material">
                {" "}
                {orderData.selectedProduct.material}
              </Descriptions.Item>
              <Descriptions.Item label="Designer Comment">
                {" "}
                {orderData.designerComment}
              </Descriptions.Item>
              <Descriptions.Item label="Sales Comment"> {orderData.salesComment}</Descriptions.Item>
            </Descriptions>
          </Col>
          <Col span={24}>
            <Divider>Fill Details</Divider>

            <Form
              form={form}
              name="basic"
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              style={{
                width: "100%",
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off">
              <Form.Item
                label="Rolls created for client"
                name="clientReceives"
                rules={[
                  {
                    required: true,
                    message: "Please input how much client is gonna receive",
                  },
                ]}>
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item label="Tape Comment" name="tapeComment">
                <TextArea />
              </Form.Item>

              <Form.Item>
                <Button block type="primary" htmlType="submit">
                  Finish Order
                </Button>
              </Form.Item>
            </Form>
            <SplitOrderDrawer orderData={orderData} user={user} setOpen={setOpen} />
          </Col>
        </Row>
      </Drawer>
    </>
  )
}
